// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/*
 * Tabela NCM tem 12 colunas + Ações. Com o padding padrão do TableView (16px por lado) e
 * cabeçalho sem quebra, "Alíquota interna (%)" e "Método de cálculo" empurravam a coluna Ações
 * pra fora da tela e a rolagem lateral voltava. Aplicado só nesta tabela via tableClassName
 * (mesmo padrão de AtualizarSelic/.tableSelic) — o CSS do TableView é compartilhado.
 */
.styles_tabelaNcm__Tsv2E th,
.styles_tabelaNcm__Tsv2E td {
  padding-left: 10px !important;
  padding-right: 10px !important;
}

/* O título pode quebrar em 2 linhas: a largura da coluna passa a ser a do dado ("18,00", "PMC")
 * e não a do título. As células de dado continuam em uma linha só (nowrap do TableView). */
.styles_tabelaNcm__Tsv2E th {
  white-space: normal !important;
  line-height: 1.25;
}
`, "",{"version":3,"sources":["webpack://./src/pages/TabelaNcm/styles.module.css"],"names":[],"mappings":"AAAA;;;;;EAKE;AACF;;EAEE,6BAA6B;EAC7B,8BAA8B;AAChC;;AAEA;2FAC2F;AAC3F;EACE,8BAA8B;EAC9B,iBAAiB;AACnB","sourcesContent":["/*\n * Tabela NCM tem 12 colunas + Ações. Com o padding padrão do TableView (16px por lado) e\n * cabeçalho sem quebra, \"Alíquota interna (%)\" e \"Método de cálculo\" empurravam a coluna Ações\n * pra fora da tela e a rolagem lateral voltava. Aplicado só nesta tabela via tableClassName\n * (mesmo padrão de AtualizarSelic/.tableSelic) — o CSS do TableView é compartilhado.\n */\n.tabelaNcm th,\n.tabelaNcm td {\n  padding-left: 10px !important;\n  padding-right: 10px !important;\n}\n\n/* O título pode quebrar em 2 linhas: a largura da coluna passa a ser a do dado (\"18,00\", \"PMC\")\n * e não a do título. As células de dado continuam em uma linha só (nowrap do TableView). */\n.tabelaNcm th {\n  white-space: normal !important;\n  line-height: 1.25;\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabelaNcm": `styles_tabelaNcm__Tsv2E`
};
export default ___CSS_LOADER_EXPORT___;
